const data = {
  pageName: "PrepaidTourist",
  eSimInfoUrl: "/ext_files/test-pages/eSim-compatible-devices.html",

  services: {
    translations: {
      url: "prepaidyou/translations",
      params: {}
    },
    liveness: {
      url: "liveness/translations",
      params: { prefix: "r.liveness.*", removePrefix: "liveness." }
    },
    getGeographicAddress: {
      url: "geographicAddress",
      params: {}
    },
    getPrepayAvailableMsisdns: {
      url: "prepaidyou/getPrepayAvailableMsisdns",
      params: {}
    },
    getPrepayDonors: {
      url: "prepaidyou/getPrepayDonors",
      params: {}
    },
    getCountries: {
      url: "prepaidyou/getCountries",
      params: {}
    },
    getIdentificationDocuments: {
      url: "prepaidyou/getIdentificationDocuments",
      params: {}
    },
    submitPrepaidYouData: {
      url: "prepaidyou/submitPrepaidYouData",
      params: {}
    },
    getGenericAppConfigs: {
      url: "prepaidyou/getGenericAppConfigs",
      params: {}
    },
    getPickupPoints: {
      url: "prepaidyou/getPickupPoints",
      params: {}
    },
    individual: {
      url: "prepaidyou/individual",
      params: {}
    },
    document: {
      url: "prepaidyou/document",
      params: {}
    },
    termsOfService: {
      url: "prepaidyou/termsOfService",
      params: {}
    },
    getPlanDetails: {
      url: "prepaidyou/getPlanDetails",
      params: {}
    },
    getMultiplePlanDetails: {
      url: "prepaidyou/getMultiplePlanDetails",
      params: {}
    },
    getThankYouPageData: {
      url: "prepaidyou/getThankYouPageData",
      params: {}
    },
    validateAndStorePrepaidYouForm: {
      url: "prepaidyou/validateAndStorePrepaidYouForm",
      params: {}
    },
    getPrepaidProperties: {
      url: "prepaidyou/getPrepaidProperties",
      params: {}
    },
    storePrepayInfo: {
      url: "prepaidyou/storePrepayInfo",
      params: {}
    },
    updatePrepayAmount: {
      url: "prepaidyou/updatePrepayAmount",
      params: {}
    }
  },
  itemsInCart: "0",
  locale: "en_US",
  documentsUploadUrl: "/documents-upload",
  statementUrl: "/document/retrieve",
  findStoreUrl: "https://www.vodafone.gr/epikoinonia/store-locator/",
  declarationImg:
    "https://www.vodafone.gr/images/d1490709395943-sim-pack-TRANSLATION.jpg"
};

exports.data = data;
